import * as React from 'react';
import isNil from 'lodash/isNil';

import { __t, applyTranslations } from 'utils/language';
import { addThousandsSeparator } from 'utils/helper/common';

applyTranslations(require('./offer-banner-details-additional-compensation-voucher.i18n.json'));

type Props = {
  amount: string | number | null
};

const MSG_KEY = 'offer_banner_details_additional_compensation_voucher';

const OfferBannerDetailsAdditionalCompensationVoucher: React.FC<Props> = ({
  amount
}: Props) => {
  if (isNil(amount)) {
    return null;
  }

  const label = __t(`${MSG_KEY}.labels.additional_voucher`);
  const text = `${label}: ${addThousandsSeparator(amount || 0)}€`;

  return (
    <div
      className="offer-banner-details-additional-compensation-voucher"
      title={text}
    >
      {text}
    </div>
  );
};

export default OfferBannerDetailsAdditionalCompensationVoucher;
